// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.barchart_featured__fS32Y {
    display: flex;
    flex-direction: row;
    flex: 1 1;
    align-items: center;
    align-content: center;
    justify-content: space-between;
}

.barchart_featuredItem__7DpMI {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1;
    margin: 0px 20px;
    padding: 20px;
    border-radius: 10px;
    cursor: pointer;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.barchart_featuredTitle__XnNd1 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
}

.barchart_featuredTitleYear__7HoYo {
    font-size: 12px;
    margin-left: 45%;
}

.barchart_featuredTitleHeader__ve16l {
    font-size: 14px;
}


.barchart_featuredTextContainer__sMTE6 {
    flex: 1 1;
    min-height: 0;
    margin-right: 40px;
    margin: 10px 0px;
    display: flex;
    align-items: center;
    justify-content: center;

}

.barchart_featuredText__8dUSk {
    font-size: 50px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--hsrcOrange);
}


.barchart_featuredIcon__5tKPe {
    font-size: 14px;
    margin-left: 5px;
    color: green;
}

.barchart_featuredIcon__5tKPe.barchart_negative__9rPwB {
    color: red;
}

.barchart_featuredSub__8zB2v {
    font-size: 15px;
    color: gray;
    display: flex;
    align-items: center;
    justify-content: center;
}

.barchart_recharts-cartesian-axis-tick__zu1Yw {
    font-size: 10px !important;
    font-weight: 200;
}


.barchart_recharts-cartesian-axis__KieG0 {
    font-size: 10px !important;
    font-weight: 100;
}


text {
    font-size: 10px;
    font-weight: 200;
}

.barchart_label_text__umdSp {
    font-size: 10px;
    font-weight: 200;
}`, "",{"version":3,"sources":["webpack://./src/components/BarChartWidget/barchart.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IAEf,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".featured {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex: 1;\r\n    align-items: center;\r\n    align-content: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitle {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 20px;\r\n}\r\n\r\n.featuredTitleYear {\r\n    font-size: 12px;\r\n    margin-left: 45%;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    font-size: 14px;\r\n}\r\n\r\n\r\n.featuredTextContainer {\r\n    flex: 1;\r\n    min-height: 0;\r\n    margin-right: 40px;\r\n    margin: 10px 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.featuredText {\r\n    font-size: 50px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--hsrcOrange);\r\n}\r\n\r\n\r\n.featuredIcon {\r\n    font-size: 14px;\r\n    margin-left: 5px;\r\n    color: green;\r\n}\r\n\r\n.featuredIcon.negative {\r\n    color: red;\r\n}\r\n\r\n.featuredSub {\r\n    font-size: 15px;\r\n    color: gray;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.recharts-cartesian-axis-tick {\r\n    font-size: 10px !important;\r\n    font-weight: 200;\r\n}\r\n\r\n\r\n.recharts-cartesian-axis {\r\n    font-size: 10px !important;\r\n    font-weight: 100;\r\n}\r\n\r\n\r\ntext {\r\n    font-size: 10px;\r\n    font-weight: 200;\r\n}\r\n\r\n.label_text {\r\n    font-size: 10px;\r\n    font-weight: 200;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featured": `barchart_featured__fS32Y`,
	"featuredItem": `barchart_featuredItem__7DpMI`,
	"featuredTitle": `barchart_featuredTitle__XnNd1`,
	"featuredTitleYear": `barchart_featuredTitleYear__7HoYo`,
	"featuredTitleHeader": `barchart_featuredTitleHeader__ve16l`,
	"featuredTextContainer": `barchart_featuredTextContainer__sMTE6`,
	"featuredText": `barchart_featuredText__8dUSk`,
	"featuredIcon": `barchart_featuredIcon__5tKPe`,
	"negative": `barchart_negative__9rPwB`,
	"featuredSub": `barchart_featuredSub__8zB2v`,
	"recharts-cartesian-axis-tick": `barchart_recharts-cartesian-axis-tick__zu1Yw`,
	"recharts-cartesian-axis": `barchart_recharts-cartesian-axis__KieG0`,
	"label_text": `barchart_label_text__umdSp`
};
export default ___CSS_LOADER_EXPORT___;
